import * as React from 'react';
import { range } from 'ramda';
import Card from 'ha/components/bootstrap/Card';
import CardBlock from 'ha/components/bootstrap/CardBlock';
import UserAvatar from 'ha/components/UserAvatar';

export interface Props {
  name: string;
  place: string;
  text: string;
  avatarUrl: string;
}

const Testimonial: React.SFC<Props> = ({ text, name, place, avatarUrl }) => (
  <Card className="box-shadow-sm border-none">
    <CardBlock className="p-x-2 p-y-2_5">
      <div className="flexbox flex-align-center m-b-2_5">
        <div className="m-r-1">
          <UserAvatar sm={true} avatarURL={avatarUrl} />
        </div>
        <div>
          <div className="text-orange color-brand">{place}</div>
          <div className="color-black">{name}</div>
          <div>
            {range(0, 5).map(index => (
              <i
                key={index}
                className="fa fa-star color-yellow fa-margin-right"
              />
            ))}
          </div>
        </div>
      </div>
      <p className="color-black">{text}</p>
    </CardBlock>
  </Card>
);

export default Testimonial;
